// Lucide icon: receipt (https://lucide.dev/icons/receipt)
import { Receipt } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconReceipt = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Receipt />
    </IconComponentStyled>
  )
}
